import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { of, concat } from 'rxjs';
import { CUSTOMERS_GRID_REFRESH } from './customers.nav.actions';
import { requestGetCustomers } from '../customers.actions';
import { autoSwitchFilterViewToDefault } from '../filtering/customers.filtering.actions';

export const customersGridRefresh = (action$) =>
  action$.pipe(
    ofType(CUSTOMERS_GRID_REFRESH),
    mergeMap(() => {
      return concat(of(autoSwitchFilterViewToDefault()), of(requestGetCustomers()));
    }),
  );
